import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";

class NewMessageSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: ""
    };
  }

  componentDidMount(){
    const { allMessages, selectedProduct } = this.props;

    this.setState({
      messages: ""
    })

    if(allMessages && allMessages.length > 0 && selectedProduct?.purchaseItemId){
      const result = allMessages.find((ele) => ele.itemId == selectedProduct.purchaseItemId )
      this.setState({
        messages: result || ""
      })
    }
  }

  render() {
    const {
      isOpen,
      toggleDropdown,
      onReplyMessageClick,
      handleMessagePDFDownload,
      allMessages,
      selectedProduct,
      lables,
      isWap,
      isMessageRead,
    } = this.props;

    const {messages} = this.state;

    const isDisabled = this.props.disableMsgBtn || false;

    //---------------------
    let messageIcon = "";

    let messageLabel = selectedProduct?.messageLabel || "";

    if ((selectedProduct.messageIconName == "icon-new-message")) {
      messageIcon = "new-message";
    }

    if ((selectedProduct.messageIconName == "icon-read")) {
      messageIcon = "read";
    }

    if ((selectedProduct.messageIconName == "icon-no-message")) {
      messageIcon = "no-message";
    }

    if ((selectedProduct.messageIconName == "icon-answered") || (messages?.repliedMessage)) {
      messageIcon = "answered";
      messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.ansmsg");
    }


    if ((selectedProduct.messageIconName == "icon-new-message") && isMessageRead) {
      messageIcon = "read";
      messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.message.readmsg");
    }

    if(selectedProduct.messageInfo === "no"){
      messageIcon = "no-message";
      messageLabel = commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.deafult.message");
    }

    //-------------------------------
    return (
      <>
        <div className={`nuevo-mensaje-container ${(!isOpen && !isWap) && 'nuevo-mensaje-container-close'}`}>
          <div className="mensaje-left">
            <div className="mensaje-icon-wrapper">
              <img
                src={
                  commonUtil.getAssetURL() +
                  `/images/messages/${
                    messageIcon
                  }.svg`
                }
                alt="new message"
              />
            </div>
            <div className="mensaje-label">
              {messageLabel || ""}
            </div>
          </div>
          <div className="mensaje-arrow-wrapper" onClick={toggleDropdown}>
            <img
              src={
                commonUtil.getAssetURL() +
                `/images/expand_${isOpen ? "less" : "more"}.svg`
              }
              alt={`expand ${isOpen ? "less" : "more"}`}
            />
          </div>
        </div>

        {isOpen && (
          <div className="message-box-container">
            {/* Header Row */}
            <div className="message-header">
              <div className="message-title">
                <span>{
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.message.label"
                )}:</span>
              </div>
              <div className="message-download">
                <div className="download-icon-wrapper">
                  <img
                    src={
                      commonUtil.getAssetURL() +
                      "/images/file_download_grey.svg"
                    }
                    alt="file download"
                    onClick={() => handleMessagePDFDownload(allMessages)}
                  />
                </div>
                <div className="download-label">
                  {commonUtil.getLabel(
                     lables.EventAdminPage,
                     "adminpage.regalosrecibidos.downloadMessages.pdf.button"
                   )}
                </div>
              </div>
            </div>

{/* Message Text */}
              {
                messages?.customMessage && (
            <div className="message-body">
<div className="message-bubble">
                <div className="message-text">
                  {messages.customMessage}
                </div>
              </div>

              {messages?.repliedMessage && (
                <div className="message-bubble right">
                  <div className="message-text">{messages?.repliedMessage}</div>
                </div>
              )}
            </div>
             )}

            {/* Reply Button */}
            {((!messages?.repliedMessage) && ((messages?.guestEmail) && (messages?.guestName))) && (
              <button className="reply-button" onClick={onReplyMessageClick} disabled={isDisabled}>
                <span className="reply-label"> {
                      messages?.customMessage ? commonUtil.getLabel(lables.EventAdminPage,'adminpage.regalosrecibidos.replymessage.button') : commonUtil.getLabel(lables.EventAdminPage,'adminpage.regalosrecibidos.sendmessage.button')
                    }</span>
              </button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default NewMessageSection;
